import React, { createContext, useContext, useState, ReactNode } from 'react';
import PopupContainer from '../components/popup_components/PopupContainer';

interface PopupContextProps {
    setPopupContent: (content: ReactNode) => void;
    openPopup: () => void;
    closePopup: () => void;
}

const PopupContext = createContext<PopupContextProps | undefined>(undefined);

export const PopupProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [popupContent, setPopupContent] = useState<ReactNode>(null);

    const openPopup = () => {
        document.getElementById("popupoverlay")?.classList.remove("hidden");
        document.getElementById("popupform")?.classList.remove("hidden");
        document.getElementById("popupbutton")?.classList.add("hidden");
    };

    const closePopup = () => {
        document.getElementById("popupoverlay")?.classList.add("hidden");
        document.getElementById("popupform")?.classList.add("hidden");
        document.getElementById("popupbutton")?.classList.remove("hidden");
    };

    return (
        <PopupContext.Provider value={{ setPopupContent, openPopup, closePopup }}>
            {children}
            <PopupContainer>{popupContent}</PopupContainer>
        </PopupContext.Provider>
    );
};

export const usePopup = (): PopupContextProps => {
    const context = useContext(PopupContext);
    if (!context) {
        throw new Error('usePopup must be used within a PopupProvider');
    }
    return context;
};